import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useCallWeek } from "@/lib/useCallWeek";

// v19-N6 F3: na de calldag opent de pagina op de volgende call; deze balk wijst op de call die net voorbij is
// als die bij deze OM nog locaties zonder de drie cijfers heeft.
export const VorigeCallBalk = ({ vorigeWeek, week, om, locaties, onOpen }) => {
  const [calls, setCalls] = useState(null);
  const info = useCallWeek(vorigeWeek && vorigeWeek !== week ? vorigeWeek : null);
  useEffect(() => {
    let alive = true;
    setCalls(null);
    if (vorigeWeek && vorigeWeek !== week && om) {
      api.get(`/locatie-calls?week=${vorigeWeek}&om=${encodeURIComponent(om)}`)
        .then((r) => { if (alive) setCalls(r.data); }).catch(() => {});
    }
    return () => { alive = false; };
  }, [vorigeWeek, week, om]);
  if (!calls || !info || vorigeWeek === week) return null;
  // v21 K4: vanaf de nieuwe regels telt "klaar" (server), daarvoor de drie cijfers.
  const nieuw = calls.some((c) => c.staat?.nieuweRegels);
  const compleet = new Set(calls.filter((c) => (c.staat?.nieuweRegels ? c.staat.klaar : c.omzet && c.pk && c.bijverkoop)).map((c) => c.locatie));
  const n = locaties.filter((l) => !compleet.has(l)).length;
  if (n === 0) return null;
  return (
    <div data-testid="vorige-call-balk" className="mb-4 flex flex-wrap items-center justify-between gap-2 rounded-md border border-zinc-200 bg-zinc-50 px-4 py-2.5">
      <p data-testid="vorige-call-balk-tekst" className="text-sm text-zinc-700">
        De call van {info.callLabel} is bij {n} {n === 1 ? "locatie" : "locaties"} {nieuw ? "nog niet klaar" : "nog zonder de drie cijfers"}.
      </p>
      <button type="button" data-testid="vorige-call-balk-open" onClick={() => onOpen(vorigeWeek)}
        className="min-h-[44px] sm:min-h-0 text-sm font-semibold text-blue-700 hover:text-blue-900">
        Naar de call van {info.callLabel}
      </button>
    </div>
  );
};
